import {Model} from "@/services/api";
import {defineAsyncComponent} from "vue";

export default class Notebook extends Model {
    static relations = {
        lafil014: require("@/services/models/lafil014").default,
        persons: require("@/services/models/person").default
    };

    toString() {
        return this.filename;
    }

    static route() {
        return 'notebooks';
    }

    detail() {
        return {
            title: this,
            component: defineAsyncComponent(() => import('@/components/notebooks/details.vue')),
            props: {value: this}
        };
    }
}
